// Module
var code = "<p class=\"circle\">4</p> <p>Select the <strong>Make a Payment</strong> button and relax for another month.</p> ";
// Exports
export default code;